import React, { useState, useEffect } from "react";
import { useContext } from "react/cjs/react.development";
import styled from "styled-components";
import { userContext } from "../../../App";
import Tile from "./Tile";
import { useHistory } from "react-router";
import { db } from "../../../firebase";
import SignInDialog from '../Folios/SignInDialog';
import SearchFolio from './SearchFolio';
import Search from './Search';
import '../../../main.css';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { createTheme, ThemeProvider } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  main: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    justifyContent: "center",
    // width: "1038px",
    // width: "100%",
    margin: "auto",
    '@media (max-width: 2560px)': {
      width: `calc(173px*12)`,
    },
    '@media (max-width: 2424px)': {
      width: `calc(173px*11)`,
    },
    '@media (max-width: 2251px)': {
      width: `calc(173px*10)`,
    },
    '@media (max-width: 2078px)': {
      width: `calc(173px*9)`,
    },
    '@media (max-width: 1904px)': {
      width: `calc(173px*8)`,
    },
    '@media (max-width: 1731px)': {
      width: `calc(173px*7)`,
    },
    '@media (max-width: 1559px)': {
      width: `calc(173px*6)`,
    },
    '@media (max-width: 1386px)': {
      width: `calc(173px*5)`,
    },
    '@media (max-width: 1212px)': {
      width: `calc(173px*4)`,
    },
    '@media (max-width: 1040px)': {
      width: `calc(173px*3)`,
    },
    '@media (max-width: 797px)': {
      width: `calc(165px*3)`,
    },
    '@media (max-width: 730px)': {
      width: `calc(165px*4)`,
    },
    '@media (max-width: 660px)': {
      width: `calc(165px*3)`,
    },
    '@media (max-width: 495px)': {
      width: `calc(165px*2)`,
    },
    '@media (max-width: 330px)': {
      width: `calc(157px*2)`,
    },
  },
  grid: {
    // margin: "auto",
    justifyContent: "left",
    margin: "auto",
    // justifyContent: "space-evenly"
    // justifyContent: "center"
  },
  // gridItem: {
  //   justifyContent: "center",
  //   margin: "0 12px",
  //   '@media (max-width: 797px)': {
  //     margin: "0 8px",
  //   },
  //   '@media (max-width: 730px)': {
  //     margin: "0 8px",
  //   },
  //   '@media (max-width: 330px)': {
  //     margin: "0 4px",
  //   }
  // }
}));
const Main = (props) => {
  const history = useHistory();
  const [post, Setpost] = useState([]);
  // const[postId,SetpostId]=useState();
  const fetchBlogs = async () => {

    const response = db.collection("posts");
    const data = await response.get();
    let arr = [];
    data.docs.forEach(item => {
      // console.log(item.data());
      var data = item.data();
      data = { ...data, id: item.id }

      arr.push(data);
      console.log(arr);
    })

    if (props.category) {
      arr = arr.filter((obj) => obj.category === props.category);
      Setpost(arr);
    }
    else {
      Setpost(arr);
      props.setallposts(arr);
    }
    // else{
    //   Setpost(arr);
    // }
    // Setpost(arr);
  }
  useEffect(() => {


    fetchBlogs();

  }, []);


  // useEffect(() => {
  //   let obj=clone(post);
  //   obj=obj.filter((arr)=>arr.category===props.category);
  //   console.log(obj);


  // }, [props.category])
  //console.log(props.searchClicked, 'cliked')
  function tileid(x) {
    localStorage.setItem(
      "postid",
      JSON.stringify({
        postid: x,
      })
    );
    history.push(`/folio/${x}`)
  }
  //console.log(props.searchClicked, 'cliked')

  const classes = useStyles();

  const customTheme = createTheme({
    breakpoints: {
      keys: ["xs", "sm", "md", "lg", "xl", "xxl"],
      values: { xs: 480, sm: 730, md: 950, lg: 1350, xl: 1920 }
    }
  });

  return (
    <div>
      {/* {props.searchtext !== '' ? <Search searchtext={props.searchtext} style={{ marginLeft: '80vw', position: 'absolute', zIndex: '1' }} /> : null} */}
      <div className={classes.main}>
        <h5 style={{ margin: "0 0 18px 12px" }}>{typeof (props.category) === 'undefined' ? 'All Folios' : props.category}</h5>

        <ThemeProvider theme={customTheme}>

          <Grid container className={classes.grid}>
            {props.searchClicked === false ? post && post.filter(obj => !props.category ? true : props.category === obj.category).map(p => {
              return (
                // xs: 0, sm: 480, md: 730, lg: 950, xl: 1280
                <Grid item
                // className={classes.gridItem}
                // xxl={1} xl={2} lg={2} md={3} sm={4} xs={4}
                >
                  <Tile Title={p.title} Image={p.img_url} id={p.id} onclick={tileid} Name={p.name} read={p.read_Count} setnavClick={props.setnavClick} />
                </Grid>
              );
            })
              :
              props.searchtitle.length !== 0 ?
                props.searchtitle.map(each => {
                  return (<SearchFolio Image={each.data.img_url} title={each.data.title} name={each.data.name} desc={each.data.description} id={each.id} onclick={tileid} />)
                })
                // post && post.filter(obj=>props.searchtext===obj.title).map(each =>{
                //   return(<SearchFolio Image={each.data.img_url} title={each.data.title} name={each.data.name} desc={each.data.description} onclick={tileid}/>)
                // })
                :
                null
            }
          </Grid>
        </ThemeProvider>
      </div>


      {props.navClick ? <SignInDialog open={true} setnavClick={props.setnavClick} /> : null}
    </div >
  );
};

// =====================Styling components=============================

// const Head = styled.p`

//     // position:absolute;
//     // width: fit-content;
//     // height: 3.95vh;
//     // left: 24.28vw;
//     // top: 18.5vh;
//     font-family: Rubik;
//     font-style: normal;
//     font-weight: normal;
//     font-size: 22px;
//     line-height: 3.95vh;
//     color: #000000;
// `
// const Container = styled.div`
// display:flex;
// flex-direction:row;
//         flex-wrap: wrap;
//         justify-content:space-between;
//         /* align-items:center; */
//         /* box-sizing:border-box; */
//     /* border: 2px solid green; */
//     position: absolute;
//     max-width: 83vw;
//     margin: auto;
//     margin-left:1.5%;
// `;


export default Main;














// import React, { useState, useEffect } from "react";
// import { useContext } from "react/cjs/react.development";
// import styled from "styled-components";
// import { userContext } from "../../../App";
// import Tile from "./Tile";
// import { useHistory } from "react-router";
// import { db } from "../../../firebase";
// import SignInDialog from '../Folios/SignInDialog';
// import SearchFolio from './SearchFolio';
// import Search from './Search';
// import '../../../main.css';

// const Main = (props) => {
//   const history = useHistory();
//   const [post, Setpost] = useState([]);
//   // const[postId,SetpostId]=useState();
//   const fetchBlogs = async () => {

//     const response = db.collection("posts");
//     const data = await response.get();
//     let arr = [];
//     data.docs.forEach(item => {
//       // console.log(item.data());
//       var data = item.data();
//       data = { ...data, id: item.id }

//       arr.push(data);
//       console.log(arr);
//     })

//     if (props.category) {
//       arr = arr.filter((obj) => obj.category === props.category);
//       Setpost(arr);
//     }
//     else {
//       Setpost(arr);
//       props.setallposts(arr);
//     }
//     // else{
//     //   Setpost(arr);
//     // }
//     // Setpost(arr);
//   }
//   useEffect(() => {


//     fetchBlogs();

//   }, []);


//   // useEffect(() => {
//   //   let obj=clone(post);
//   //   obj=obj.filter((arr)=>arr.category===props.category);
//   //   console.log(obj);


//   // }, [props.category])
//   //console.log(props.searchClicked, 'cliked')
//   function tileid(x) {
//     localStorage.setItem(
//       "postid",
//       JSON.stringify({
//         postid: x,
//       })
//     );
//     history.push(`/folio/${x}`)
//   }
//   //console.log(props.searchClicked, 'cliked')
//   return (
//     <div>
//       {/* {props.searchtext!=='' ? <Search searchtext={props.searchtext} style={{marginLeft: '80vw', position: 'absolute', zIndex: '1'}}/> : null} */}
//       <Head>{typeof (props.category) === 'undefined' ? 'All Folios' : props.category}</Head>
//       <Container style={{ width: '72.47%' }} className='folios'>
//         {
//           <div className="container">
//             <div class="row">
//               {props.searchClicked === false ? post && post.filter(obj => !props.category ? true : props.category === obj.category).map(p => {
//                 return (

//                   <div className="col-xs-12 col-sm-12 col-md-6 col-lg-2">
//                     <Tile Title={p.title} Image={p.img_url} id={p.id} onclick={tileid} Name={p.name} read={p.read_Count} setnavClick={props.setnavClick} />
//                   </div>
//                 );
//               })
//                 :
//                 props.searchtitle.length !== 0 ?
//                   props.searchtitle.map(each => {
//                     return (<SearchFolio Image={each.data.img_url} title={each.data.title} name={each.data.name} desc={each.data.description} id={each.id} onclick={tileid} />)
//                   })
//                   // post && post.filter(obj=>props.searchtext===obj.title).map(each =>{
//                   //   return(<SearchFolio Image={each.data.img_url} title={each.data.title} name={each.data.name} desc={each.data.description} onclick={tileid}/>)
//                   // })
//                   :
//                   null
//               }
//             </div>
//           </div>
//         }
//       </Container>
//       {props.navClick ? <SignInDialog open={true} setnavClick={props.setnavClick} /> : null}
//     </div>
//   );
// };

// // =====================Styling components=============================

// const Head = styled.p`

//     position:absolute;
//     width: fit-content;
//     height: 3.95vh;
//     left: 24.28vw;
//     top: 18.5vh;
//     font-family: Rubik;
//     font-style: normal;
//     font-weight: normal;
//     font-size: 22px;
//     line-height: 3.95vh;
//     color: #000000;
// `
// const Container = styled.div`
// display:flex;
// flex-direction:row;
//         flex-wrap: wrap;
//         justify-content:space-between;
//         /* align-items:center; */
//         /* box-sizing:border-box; */
//     /* border: 2px solid green; */
//     position: absolute;
//     max-width: 83vw;
//     margin: auto;
//     margin-left:1.5%;
// `;


// export default Main;